import { createContext, useContext } from "react";

const noop = () => {};

export const PeopleContext = createContext({
  // People
  people: [],
  addPerson: noop,
  removePerson: noop,
  updatePerson: noop,

  // Notifications
  notifs: [],
  setNotifs: noop,
  persistRead: noop,
  persistReadAll: noop,
  notifyNotifDeleted: noop,
  notifSettings: null,
  setNotifSettings: noop,

  // Display / theme
  compact: false,
  setCompact: noop,
  themeKey: "parchment",
  setThemeKey: noop,
  customTheme: null,
  setCustomTheme: noop,

  // Agreements
  agreements: [],
  setAgreements: noop,
  fetchAgreements: noop,
  saveAgreement: noop,
  deleteAgreement: noop,

  // Calendar events
  calEvents: [],
  setCalEvents: noop,

  // Auth / user
  user: null,
  setUser: noop,
  userId: null,

  // Google Calendar
  googleCalAvail: null,
  setGoogleCalAvail: noop,
  googleCalStatus: null,
  setGoogleCalStatus: noop,
  fetchGoogleCalEvents: noop,
  googleAccounts: null,
  setGoogleAccounts: noop,

  // iCloud Calendar
  icloudCalStatus: null,
  setIcloudCalStatus: noop,
  icloudCalAvail: null,
  setIcloudCalAvail: noop,
  icloudCalendars: null,
  setIcloudCalendars: noop,
  icloudSelectedCalIds: null,
  setIcloudSelectedCalIds: noop,
  fetchICloudCalEvents: noop,

  // Outlook Calendar
  outlookCalStatus: null,
  setOutlookCalStatus: noop,
  outlookCalAvail: null,
  setOutlookCalAvail: noop,
  outlookCalendars: null,
  setOutlookCalendars: noop,
  outlookSelectedCalIds: null,
  setOutlookSelectedCalIds: noop,
  fetchOutlookCalEvents: noop,

  // OFW Calendar
  ofwCalStatus: null,
  setOfwCalStatus: noop,
  ofwUploadedAt: null,
  setOfwUploadedAt: noop,
  fetchOfwCalEvents: noop,

  // Yahoo Calendar
  yahooCalStatus: null,
  setYahooCalStatus: noop,
  yahooCalAvail: null,
  setYahooCalAvail: noop,
  yahooCalendars: null,
  setYahooCalendars: noop,
  yahooSelectedCalIds: null,
  setYahooSelectedCalIds: noop,
  fetchYahooCalEvents: noop,

  // CalDAV Calendar
  caldavCalStatus: null,
  setCaldavCalStatus: noop,
  caldavCalAvail: null,
  setCaldavCalAvail: noop,
  caldavCalendars: null,
  setCaldavCalendars: noop,
  caldavSelectedCalIds: null,
  setCaldavSelectedCalIds: noop,
  fetchCaldavCalEvents: noop,

  // Calendar custom names
  calendarCustomNames: {},
  setCalendarCustomNames: noop,

  // Orbit calendar
  fetchOrbitCalEvents: noop,

  // Preferences
  prefs: null,
  setPrefs: noop,

  // Privacy
  priv: null,
  setPriv: noop,
  hideOffline: false,
  setHideOffline: noop,
  blockNotes: false,
  setBlockNotes: noop,
  privOverrides: {},
  setPrivOverrides: noop,

  // Accounts
  accounts: [],
  setAccounts: noop,

  // Connection requests
  connectionRequests: [],
  setConnectionRequests: noop,
  respondToConnectionRequest: noop,
  pendingOutgoingIds: [],
  pendingOutgoingRequests: [],
  rescindConnectionRequest: noop,
  fetchPeerAvailability: noop,

  // Scheduling requests
  schedulingRequests: [],
  setSchedulingRequests: noop,
  pendingSchedulingIds: [],
  respondToSchedulingRequest: noop,
  sendSchedulingRequest: noop,
  recallSchedulingRequest: noop,
  counterProposeSchedulingRequest: noop,
  fetchSchedulingRequests: noop,
  fetchSentSchedulingResponses: noop,
  fetchCounterProposalOutcomes: noop,
});

export const usePeople = () => useContext(PeopleContext);
